import { initStore } from '../../../common';
import { actions } from './actions';

export const moneyDropStore = (): void => {
	const initialState = {
		slice: 'MONEY_DROP',
		campaigns: [],
		campaignsLoading: false,
		pagesTotal: 1,
		currentPage: 1,
		partners: [],
		providers: [],
		statuses: [],
		rows: [],
		columns: ['ID', 'Name', 'Description', 'Status', 'From - Until', 'Currency'],
		activePartners: [],
		filtering: false,
		filters: [{ name: 'searchType', value: 'id' }],
		globalErrors: [],
		globalSuccess: '',
		games: [],
		campaignForm: {
			status: [],
			activePartners: [],
			partners: [],
			from_date: '',
			to_date: '',
			games: [],
			notes: '',
			game_provider_id: [],
			provider_game_id_desktop: '',
			provider_game_id_mobile: '',
			aams_type_id: [],
			rtp: '',
			volatility: '',
			wagering_weight: '',
			rules: '',
			is_slot: false,
			active: false,
			custom_fields: [],
			number_of_prizes: ['0'],
			prize_value: ['0'],
			money_drop_currency: [],
			all_games: false,
			all_users: false,
			thirdparty_campaign_id: '',
			device: [],
			provider_id: [],
			allow_api_award: false,
			auto_award_on_launch: false,
			formErrors: {},
			globalSuccess: '',
		},
	};

	initStore(actions, initialState);
};
